import { AuthFullLayout } from 'src/layouts';

export const Unauthorized = () => {
  return (
    <AuthFullLayout>
      <h1>Unauthorized</h1>
    </AuthFullLayout>
  );
};
